
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { CardFormValues } from '@/components/payment/CardPaymentForm';
import CardFormFields from '@/components/payment/CardFormFields';

interface AdvancedTransferFormProps {
  title: string;
  description: string;
  recipientLabel: string;
  amountLabel: string;
  onBack: () => void;
  onSubmit: () => void;
  form: UseFormReturn<CardFormValues>;
  recipientId: string;
  setRecipientId: (value: string) => void;
  transferAmount: string;
  setTransferAmount: (value: string) => void;
  isProcessing: boolean;
  buttonText: string;
}

const AdvancedTransferForm: React.FC<AdvancedTransferFormProps> = ({
  title,
  description,
  recipientLabel,
  amountLabel,
  onBack,
  onSubmit,
  form,
  recipientId,
  setRecipientId,
  transferAmount,
  setTransferAmount,
  isProcessing,
  buttonText
}) => {
  return (
    <div className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onBack}
          className="h-8 w-8"
        >
          <ArrowLeft size={18} />
        </Button>
        <h3 className="text-lg font-medium">{title}</h3>
      </div>
      
      <p className="text-sm text-gray-500 mb-6">{description}</p>
      
      <div className="space-y-4 mb-6">
        <div>
          <label htmlFor="recipientId" className="block text-sm font-medium text-gray-700 mb-1">
            {recipientLabel}
          </label>
          <Input
            id="recipientId"
            value={recipientId}
            onChange={(e) => setRecipientId(e.target.value)}
            placeholder="user@example.com or #1234567"
            className="w-full"
          />
        </div>
        
        <div>
          <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
            {amountLabel}
          </label>
          <Input
            id="amount"
            type="number"
            value={transferAmount}
            onChange={(e) => setTransferAmount(e.target.value)}
            placeholder="0.00"
            min="0.01"
            step="0.01"
            className="w-full"
          />
        </div>
      </div>
      
      <CardFormFields form={form} />
      
      <div className="mt-6">
        <Button 
          onClick={onSubmit}
          className="w-full bg-primary" 
          disabled={isProcessing}
        >
          {isProcessing ? "Processing..." : buttonText}
        </Button>
      </div>
    </div>
  );
};

export default AdvancedTransferForm;
